/**
 * Kinds of record and their status words, from the codes the API stores
 * (`PurchaseOrder`, `Posted`). The glossary's status table says to show the
 * word in the person's language and never the raw value, and Arabic status
 * words agree with the record's gender, so a status is always looked up with
 * its record type (`status.SalesInvoice.Posted` is «مُرحَّلة»,
 * `status.JournalEntry.Posted` is «مُرحَّل»).
 *
 * A kind or a value the catalog does not have is shown as sent, never blank:
 * a new status must not empty a cell.
 *
 * Other codes the API stores (an account type, a valuation method, a risk
 * level) are words under `values.<kind>` (catalogs/screens.en.ts), read with
 * `valueLabel`, by the same rule.
 */
import type { TFunction } from "./types";

/** A record kind (`PurchaseOrder`) as a word. */
export function recordTypeLabel(t: TFunction, type: string): string {
  return t(`records.types.${type}`, { defaultValue: type });
}

/** A record's status in the active language, agreeing with its kind. */
export function statusLabel(
  t: TFunction,
  type: string,
  status: string,
): string {
  return t(`status.${type}.${status}`, { defaultValue: status });
}

/** A stored code of the given kind (`accountType`, `Asset`) as a word. */
export function valueLabel(t: TFunction, kind: string, value: string): string {
  return t(`values.${kind}.${value}`, { defaultValue: value });
}
